// import ZACKS_TICKER_MAP from '../assets/zacks-tickers-map';

export const ZACK_DFP_SLUG = 'Zacks';

export const isZacksAppliesToTickers = async (tickers: string[]): Promise<boolean> => {
  if (!Array.isArray(tickers)) {
    return false;
  }

  return import('../assets/zacks-tickers-map').then(({ default: ZACKS_TICKER_MAP }) => {
    return tickers.some(ticker => {
      return ZACKS_TICKER_MAP.includes(ticker);
    });
  });
};
